// 命名形式：业务名称+接口名称

// realtime
const REALTIME_RETENTION = 'realtime_retention';
const REALTIME_USERTAG = 'realtime_usertag';
const REALTIME_NEW_ACTIVE_ONLINE = 'realtime_new_active_online';
const REALTIME_RETENTION_DAU = 'realtime_retention_dau';
const REALTIME_OVERALL_USER = 'realtime_overall_user';
const REALTIME_CHANGE_NEW_ACTIVE_ONLINE = 'realtime_change_new_active_online';
const REALTIME_CHANGE_RETENTION_DAU = 'realtime_change_retention_dau';

// overview
const OVERVIEW_DAILY_REGION = 'overview_daily_countries_region_zone';
const OVERVIEW_DAILY_METRICS = 'overview_daily_metrics_users';
const OVERVIEW_DAILY_KEY_METRICS = 'overview_daily_key_metrics';
const OVERVIEW_WEEKLY_KEY_METRICS = 'overview_weekly_key_metrics';
const OVERVIEW_MONTHLY_KEY_METRICS = 'overview_monthly_key_metrics';
const OVERVIEW_DAILY_KEY_METRICS_TREND = 'overview_daily_key_metrics_trend';
const OVERVIEW_WEEKLY_KEY_METRICS_TREND = 'overview_weekly_key_metrics_trend';
const OVERVIEW_MONTHLY_KEY_METRICS_TREND = 'overview_monthly_key_metrics_trend';

const OVERVIEW_WEEK_REGION = 'overview_week_countries_region_zone';
const OVERVIEW_WEEK_METRICS = 'overview_week_metrics_users';

const OVERVIEW_MONTH_REGION = 'overview_month_countries_region_zone';
const OVERVIEW_MONTH_METRICS = 'overview_month_metrics_users';

// engagement
const REGISTER_TOTAL_NEW_USERS = "register_total_new_users";
const ACTIVE_METRICS = 'active_metrics'
const ACTIVE_USER_ROLE = 'active_user_role'
const ACTIVE_OVERALL_ONLINE_TIME = 'active_overall_online_time'
const ACTIVE_DEGREE_WEEK = 'active_degree_week';
const ACTIVE_DEGREE_MONTH = 'active_degree_month';
const ACTIVE_DEGREE_BIWEEK = 'active_degree_biweek';
const ENGAGEMENT_RETENTION_TABLE = 'engagement_retention_table';
const ENGAGEMENT_RETENTION_TREND = 'engagement_retention_trend';
const ENGAGEMENT_CHURN_USERS_DETAILS = 'engagement_churn_users_details';
const ENGAGEMENT_RETURN_USERS_DETAILS = 'engagement_return_users_details';
const REGISTER_NEW_DISTRIBUTION = 'register_new_distribution';
const REGISTER_USERS_DISTRIBUTION = 'register_users_distribution'
const ACTIVE_COUNTRY_REGION_ZONE = 'active_countries_region_zone';

// monetization
const MONETIZATION_PAYMENT_REVENUE = 'monetization_payment_revenue'

// PC Console 模块
const PC_OVERVIEW_DAILY_METRICS = 'pc_overview_daily_metrics_users';
const PC_OVERVIEW_DAILY_REGION = 'pc_overview_daily_countries_region_zone';
const PC_OVERVIEW_DAILY_KEY_METRICS = 'pc_overview_daily_key_metrics'
const PC_OVERVIEW_DAILY_KEY_METRICS_TREND = 'pc_overview_daily_key_metrics_trend'
// monetization
const MONETIZATION_MTX_REVENUE = 'monetization_mtx_revenue'

export {
    REALTIME_USERTAG,
    REALTIME_RETENTION,
    REALTIME_NEW_ACTIVE_ONLINE,
    REALTIME_RETENTION_DAU,
    REALTIME_OVERALL_USER,
    OVERVIEW_DAILY_REGION,
    REALTIME_CHANGE_NEW_ACTIVE_ONLINE,
    OVERVIEW_DAILY_METRICS,
    REALTIME_CHANGE_RETENTION_DAU,

    OVERVIEW_WEEK_REGION,
    OVERVIEW_WEEK_METRICS,
    OVERVIEW_DAILY_KEY_METRICS,
    OVERVIEW_WEEKLY_KEY_METRICS,
    OVERVIEW_MONTHLY_KEY_METRICS,
    OVERVIEW_DAILY_KEY_METRICS_TREND,
    OVERVIEW_WEEKLY_KEY_METRICS_TREND,
    OVERVIEW_MONTHLY_KEY_METRICS_TREND,
    OVERVIEW_MONTH_REGION,
    OVERVIEW_MONTH_METRICS,
    REGISTER_TOTAL_NEW_USERS,
    ACTIVE_METRICS,
    ACTIVE_USER_ROLE,
    ACTIVE_OVERALL_ONLINE_TIME,
    ACTIVE_DEGREE_WEEK,
    ACTIVE_DEGREE_BIWEEK,
    ACTIVE_DEGREE_MONTH,
    ENGAGEMENT_RETENTION_TABLE,
    ENGAGEMENT_RETENTION_TREND,
    ENGAGEMENT_CHURN_USERS_DETAILS,
    ENGAGEMENT_RETURN_USERS_DETAILS,

    REGISTER_NEW_DISTRIBUTION,
    REGISTER_USERS_DISTRIBUTION,
    ACTIVE_COUNTRY_REGION_ZONE,

    MONETIZATION_PAYMENT_REVENUE,

    // PC Console 模块
    PC_OVERVIEW_DAILY_METRICS,
    PC_OVERVIEW_DAILY_REGION,
    PC_OVERVIEW_DAILY_KEY_METRICS,
    PC_OVERVIEW_DAILY_KEY_METRICS_TREND,

    MONETIZATION_MTX_REVENUE,
}